/**
 * Cache Manager Utility
 * Handles clearing cache while preserving specific keys
 */

// Keys that should NOT be cleared from localStorage
const PRESERVE_KEYS = [
  "_gcl_ls",
  "access_token",
  "refresh_token",
  "rzp_checkout_anon_id",
  "rzp_device_id",
  "hasCompletedOnboarding",
  "preparation_year",
  "upsc_journey_stage",
  "email",
  "referral_code",
  "referralCode",
  "user_id",
  "hastour",
];

/**
 * Clear all cache except for preserved keys
 */
export const clearCacheSelectively = () => {
  try {
    
    // Get all keys from localStorage
    const allKeys = Object.keys(localStorage);
    
    // Filter keys to delete
    const keysToDelete = allKeys.filter(key => !PRESERVE_KEYS.includes(key));
    
    // Delete non-preserved keys
    keysToDelete.forEach(key => {
      localStorage.removeItem(key);
    });
    
    
    return {
      success: true,
      deletedKeys: keysToDelete,
      preservedKeys: PRESERVE_KEYS,
    };
  } catch (error) {
    console.error("❌ Error clearing cache:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Get list of preserved keys
 */
export const getPreservedKeys = () => {
  return [...PRESERVE_KEYS];
};

/**
 * Get list of currently cached keys (excluding preserved ones)
 */
export const getCachedKeys = () => {
  const allKeys = Object.keys(localStorage);
  return allKeys.filter(key => !PRESERVE_KEYS.includes(key));
};

/**
 * Clear cache on page load/fresh start
 * Runs when user opens the site for a fresh session
 */
export const clearCacheOnPageLoad = () => {
  try {
    clearCacheSelectively();
  } catch (error) {
    console.error("❌ Error clearing cache on page load:", error);
  }
};
